<template>
  <crud-table
    hide-excel
    create-route="tickets.create"
    :columns="fields"
    vuex-prefix="tickets"
    create-role="Developer"
    fetch-address="tickets"
  >
    <template #cell(subject)="data">
      <span style="font-size: 10px">تیکت شماره {{ data.item.id }}</span>
      <br />
      <router-link :to="{ name: 'tickets.show', params: { id: data.item.id } }">
        {{ data.item.subject }}
      </router-link>
    </template>
    <template #cell(department_id)="data">
      {{ data.item.department ? data.item.department.name : "-------------" }}
    </template>
    <template #cell(ticket_section_id)="data">
      {{
        data.item.ticket_section
          ? data.item.ticket_section.name
          : "-------------"
      }}
    </template>
    <template #cell(ticketable_id)="data">
      {{ data.item.ticketable ? data.item.ticketable.name : "-------------" }}
    </template>
    <template #cell(priority)="data">
      <span v-if="data.item.priority === 1">کم</span>
      <span v-if="data.item.priority === 2">متوسط</span>
      <span v-if="data.item.priority === 3">زیاد</span>
    </template>
    <template #cell(ticket_status_id)="data">
      <span
        :class="{
          'text-warning': data.item.ticket_status_id === 1,
          'text-success': data.item.ticket_status_id === 2,
          'text-primary': data.item.ticket_status_id === 3,
          'text-danger': data.item.ticket_status_id === 4,
        }"
        >{{ data.item.ticket_status.name }}</span
      >
    </template>
    <template #cell(actions)="data">
      <table-action-buttons
        fa-title="تیکت"
        route="tickets"
        hidden-delete-button
        hidden-edit-button
        :record-id="data.item.id"
        :delete-title="data.item.name"
        @deleted="data.itemDeleted(data.itemDeleted(data.item))"
      >
        <template slot="extra-buttons">
          <span
            @click="closeTickets(data.item)"
            v-if="
              $store.state.auth.user.is_admin && data.item.ticket_status_id != 4
            "
            style="cursor: pointer"
            title="بستن تیکت"
            v-b-tooltip.hover
            class="ml-4"
          >
            <i class="mdi mdi-close-circle font-size-18 text-danger"></i>
          </span>
        </template>
      </table-action-buttons>
    </template>
  </crud-table>
</template>
<script>
export default {
  data() {
    return {
      departmentOptions: [],
      statusOptions: [],
      sectionOptions: [],
    };
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    fields() {
      return [
        {
          key: "subject",
          sortable: true,
          label: "موضوع",
          thStyle: { width: "180px" },
          filter: {
            component: "SearchFilter",
            operator: "$lk",
            value: "",
          },
        },
        {
          key: "department_id",
          sortable: true,
          label: "دپارتمان",
          thStyle: { width: "180px" },
          filter: {
            component: "SelectFilter",
            operator: "$in",
            value: [],
            items: this.departmentOptions,
          },
        },
        {
          key: "ticket_section_id",
          sortable: true,
          label: "بخش مربوطه",
          thStyle: { width: "180px" },
          filter: {
            component: "SelectFilter",
            operator: "$in",
            value: [],
            items: this.sectionOptions,
          },
        },
        {
          key: "ticketable_id",
          sortable: true,
          label: "رکورد مربوطه",
          thStyle: { width: "180px" },
        },
        {
          key: "ticket_status_id",
          sortable: false,
          label: "وضعیت",
          thStyle: { width: "180px" },
          filter: {
            component: "SelectFilter",
            operator: "$in",
            value: [],
            items: this.statusOptions,
          },
        },
      ];
    },
  },
  mounted() {
    this.fetchMetaData();
  },
  methods: {
    fetchMetaData() {
      this.$axios.get(`tickets/meta-data`).then((res) => {
        this.departmentOptions = res.data.departments.map((item) => {
          return {
            value: item.id,
            text: item.name,
          };
        });
        this.sectionOptions = res.data.sections.map((item) => {
          return {
            value: item.id,
            text: item.name,
          };
        });
        this.statusOptions = res.data.statuses.map((item) => {
          return {
            value: item.id,
            text: item.name,
          };
        });
      });
    },
    closeTickets(ticket) {
      this.$swal
        .fire({
          title: `بستن تیکت`,
          text: `آیا از بستن تیکت ${ticket.subject} مطمئن هستید؟ `,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: "بله",
          cancelButtonText: "خیر",
        })
        .then((result) => {
          if (result.value) {
            this.$axios.post(`tickets/${ticket.id}/close`).then(() => {
              this.$swal.fire("موفق!", `تیکت با موفقیت بسته شد`, "success");
            });
          }
        });
    },
  },
};
</script>
